{
  "headings": {
    "parties": "Parter",
    "tenantLeaves_one": "En person flyttar ut",
    "tenantLeaves_other": "{{count}} personer flyttar ut",
    "modificationPreview": "Förhandsgranskning av ändringar",
    "thankYou": "Tack",
    "confirmationRejected": "Ändringsanmälan har avvisats.",
    "addTenant": "Lägg till boende"
  },
  "view": {
    "title": "Avtalsändringar",
    "addTenantTitle": "Lägg till ny boende"
  },
  "labels": {
    "movingOutDate": "Utflyttningsdatum",
    "modificationDescription": "Ytterligare information",
    "transferDestination": "Till vem vill du överföra avtalet",
    "movingOutTenant": "Utflyttande person",
    "newContractParty": "Ny avtalspart",
    "socialSecurityNumber": "Personnummer",
    "firstName": "Förnamn",
    "lastName": "Efternamn",
    "email": "E-post",
    "phoneNumber": "Telefonnummer",
    "change": "Ändring",
    "personAdded": "Person tillagd",
    "personInformation": "Personuppgifter",
    "contractEnds": "Avslutar",
    "contractEnded": "Avslutat"
  },
  "placeholders": {
    "modificationDescription": "Du kan lägga till ytterligare information om du vill"
  },
  "buttons": {
    "backToEdit": "Tillbaka för att redigera",
    "confirmModification": "Bekräfta avtalsändringar",
    "rejectModification": "Avvisa avtalsändringar",
    "back": "Tillbaka",
    "addPerson": "Lägg till person",
    "restart": "Börja om"
  },
  "texts": {
    "confirmationInstruction": "Granska de angivna uppgifterna och godkänn eller avvisa avtalsändringarna. Om uppgifterna behöver ändras, avvisa ändringarna och fyll i uppsägningsformuläret på nytt.",
    "tenantLeavingDescription": "Avtalet förblir giltigt och ansvaret för lägenheten övergår till de andra avtalsparterna.",
    "confirmationAccepted": "Ändringsanmälan har bekräftats av dig.",
    "terminationRequestExists": "En uppsägningsbegäran har redan gjorts för detta avtal.",
    "returnFromAuthReminder": "Kom ihåg att anmälan om avtalsändring skickas för behandling först när du har genomfört stark autentisering och återvänt till boendesidorna. Om autentiseringen avbryts förblir avtalsändringen ofullständig.",
    "otherContractPartyTerminationInfo": "En annan avtalspart kan endast sägas upp genom att hela avtalet sägs upp. Välj alla parter om du vill säga upp avtalet."
  },
  "terminationDisallowedReasons": {
    "pending": "Väntar",
    "ended": "Avslutar",
    "contract_terminated": "Avtalet har redan sagts upp.",
    "pending_termination_tenant_approvals": "Alla boende har ännu inte godkänt uppsägningen.",
    "pending_termination_review": "Uppsägningen väntar på behandling hos fastighetsbolaget.",
    "is_estate_contract": "Avtalet tillhör ett dödsbo.",
    "has_guardian_of_interests": "En av avtalsparterna har en intressebevakare.",
    "missing_resident_users": "Alla avtalsparter har inte ett konto till boendesidorna.",
    "contract_tag": "Avtalet har en tagg som förhindrar uppsägning.",
    "not_contract_party": "Du är inte en part i detta avtal.",
    "tenants_with_undetermined_age": "Avtalet innehåller boende vars ålder saknas.",
    "has_company_tenant": "Avtalet har ett företag som part.",
    "pending_modification_request": "Ett öppet ändringsförslag förhindrar uppsägningen.",
    "not_started_yet": "Avtalet har ännu inte trätt i kraft.",
    "open_continuation_offer": "Ett öppet fortsättningserbjudande förhindrar uppsägningen."
  },
  "confirmationError": {
    "noIdentityVerifier": "Användarens identitet kunde inte verifieras",
    "noIdentity": "Användarens identitet kunde inte behandlas",
    "noUser": "Ett fel uppstod vid hämtning av användarinformation",
    "noAttributes": "Användarens personuppgifter är ofullständiga",
    "identityMismatch": "Identiteten matchar inte den inloggade användaren",
    "initFailed": "Ett fel uppstod vid bekräftande av ändringsanmälan",
    "cancelled": "Autentisering avbruten",
    "addTenantInitFailed": "Det gick inte att lägga till boende"
  },
  "errors": {
    "outOfService": "Tyvärr är avtalsändring inte möjlig just nu. Försök igen senare.",
    "formErrorTitle": "Fel vid skickande av ändringsanmälan",
    "confirmErrorTitle": "Fel vid bekräftande av ändringsanmälan",
    "pending_contract_resign": "Avtalet väntar på att bli återundertecknat."
  },
  "confirmationState": {
    "modificationConfirmed": "Ändringsanmälan har skickats",
    "modificationPending": "Ändringsanmälan har skickats och väntar på godkännande från andra parter",
    "modificationRejected": "Skickandet av ändringsanmälan har avbrutits",
    "modificationNotFound": "Ingen information hittades med det angivna ändringsanmälans-ID:t",
    "modificationLoading": "Laddar status för ändringsanmälan...",
    "addTenantSuccess": "Ändringen har sparats"
  }
}
